import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { Icon } from "@portal/lib/icons/icons";
import { SourceApp } from "@portal/types/entities/source-app";

type SourceTypeIconConfig = Record<
  SourceApp,
  { label: string; icon: React.ReactNode }
>;

const t = {
  addedVia: "Added Via",
};

const sourceTypeConfig: SourceTypeIconConfig = {
  GROWFIN_INTEGRATION: {
    label: "Manually",
    icon: (
      <Icon
        icon={["far", "circle-nodes"]}
        color="var(--cyan-4)"
        fontSize={16}
      />
    ),
  },
  CUSTOMER_PORTAL: {
    label: "Customer Portal",
    icon: (
      <Icon
        icon={["fal", "images-user"]}
        color="var(--geekblue-6)"
        fontSize={16}
      />
    ),
  },
  CRM: {
    label: "Integrations",
    icon: (
      <Icon
        icon={["far", "circle-user"]}
        color="var(--green-4)"
        fontSize={16}
      />
    ),
  },
};

function ContactSource(props: { sourceType: SourceApp; date?: string }) {
  const { sourceType, date } = props;

  const Title = (
    <Flex vertical space="2">
      <TypographyText
        style={{ color: "var(--gray-1)", wordBreak: "break-word" }}
      >
        {t.addedVia}
        <br />
        {sourceTypeConfig[sourceType].label}
      </TypographyText>
      <TypographyText fs="12" style={{ color: "var(--gray-6)" }}>
        {date}
      </TypographyText>
    </Flex>
  );
  return <ToolTip title={Title}>{sourceTypeConfig[sourceType].icon}</ToolTip>;
}

export { ContactSource };
